/**
 * Menu Handler Module
 * Handles mobile menu toggle, submenu accordion, and anchor links
 */

const handleMenu = () => {
	const $openBtn = $('.js-open-menu');
	const $menu = $('.js-menu');
	const $closeBtn = $('.js-close-menu');

	// Menu toggle functionality
	$openBtn.on('click', function(event) {
		event.preventDefault();
		$menu.addClass('is-active').closest('.header').addClass('is-active');
	});

	$closeBtn.on('click', function(event) {
		event.preventDefault();
		$menu.removeClass('is-active').closest('.header').removeClass('is-active');
	});

	// Submenu accordion for mobile
	$menu.find('.menu__nav-title').on('click', function() {
		const windowSize = $(window).width();
		if (windowSize < 768) {
			const $this = $(this);
			$this
				.toggleClass('is-active')
				.siblings('ul')
				.slideToggle()
				.closest('.menu__nav')
				.siblings('.menu__nav')
				.find('ul')
				.slideUp()
				.siblings()
				.removeClass('is-active')
				.closest('.col-md-4')
				.siblings('.col-md-4')
				.find('ul')
				.slideUp()
				.siblings()
				.removeClass('is-active');
		}
	});

	// Special anchor link pages
	$menu.find('a.anchorLink').on('click', function() {
		// close menu
		$menu.removeClass('is-active').closest('.header').removeClass('is-active');
		// follow link after closing menu
		return true;
	});
};

export default handleMenu;
